import { defineAppConfig } from '#imports';

export default defineAppConfig({
	monospace: {
		workspaceSlug: undefined as string | undefined,
	},
});
